<h2 mat-dialog-title>{{ data.title || 'Confirm Action' }}</h2>
<mat-dialog-content>
  {{ data.message || 'Are you sure you want to proceed?' }}
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">{{ data.cancelButtonText || 'Cancel' }}</button>
  <button mat-button color="warn" (click)="onConfirm()">{{ data.confirmButtonText || 'Confirm' }}</button>
</mat-dialog-actions>
